


// import React, { useEffect, useState } from "react";
// import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
// import { InverterDetail } from "../../../../../../api/Api";

// function Dashboard7Location(props) {
//   const [logData, setLogData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const [credentials] = useState({
//     LOGIN_ID: localStorage.getItem("LoginID") || "",
//     LOC_CODE: localStorage.getItem("LCODE") || "",
//     PASS_KEY: localStorage.getItem("PASS_KEY") || "xyz",
//     WEB_KEY: localStorage.getItem("WEB_KEY") || "WEBXYZ321",
//   });

//   const fetchLogData = async () => {
//     setLoading(true);
//     setError(null);
//     setLogData([]);
//     try {
//       const res = await InverterDetail(credentials);
//       if (res?.data && Array.isArray(res.data)) {
//         setLogData(res.data);
//       } else {
//         setLogData([]);
//       }
//     } catch (err) {
//       console.error("Error fetching data:", err);
//       setError("Failed to fetch data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, [credentials.LOGIN_ID]);

//   const locations = logData
//     .filter((data) => data.Latitude && data.Longitude)
//     .map((data) => ({
//       lat: parseFloat(data.Latitude),
//       lng: parseFloat(data.Longitude),
//       label: data.NAME,
//       address: data.USR,
//       status: data.STS,
//       KW: data.KW,
//     }));

//   const [activeMarker, setActiveMarker] = useState(null);
//   const [selectedPlace, setSelectedPlace] = useState({});
//   const [showingInfoWindow, setShowingInfoWindow] = useState(false);

//   const onMarkerHover = (props, marker, location) => {
//     setSelectedPlace({
//       name: location.label,
//       address: location.address,
//       status: location.status,
//       KW: location.KW,
//     });
//     setActiveMarker(marker);
//     setShowingInfoWindow(true);
//   };

//   const onInfoWindowClose = () => {
//     setActiveMarker(null);
//     setShowingInfoWindow(false);
//   };

//   return (
//     <div className="">
//       <div className="row">
//         <div className="col-md-12">
//           <div style={{ height: "500px", width: "100%", overflow: "hidden" }}>
//             <Map google={props.google} zoom={5} initialCenter={{ lat: 27.0, lng: 80.0 }}>
//               {locations.map((location, index) => {
//                 const markerIcon =
//                   location.status === "Offline"
//                     ? { url: `http://maps.google.com/mapfiles/ms/icons/red-dot.png` }
//                     : { url: `http://maps.google.com/mapfiles/ms/icons/green-dot.png` };

//                 return (
//                   <Marker
//                     key={index}
//                     position={{ lat: location.lat, lng: location.lng }}
//                     name={location.label}
//                     onMouseover={(props, marker) => onMarkerHover(props, marker, location)}
//                     icon={markerIcon}
//                   />
//                 );
//               })}

//               <InfoWindow marker={activeMarker} visible={showingInfoWindow} onClose={onInfoWindowClose}>
//                 <div>
//                   <h4>{selectedPlace.name}</h4>
// <p><strong>Address:</strong> {selectedPlace.address}</p>
// <p><strong>Status:</strong> {selectedPlace.status}</p>
// <p><strong>KW:</strong> {selectedPlace.KW}</p>
//                 </div>
//               </InfoWindow>
//             </Map>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default GoogleApiWrapper({
//   apiKey: "AIzaSyBoA0HlBswePv6ZmOewvoJK49FfIdd1PyI",
// })(Dashboard7Location);

// 2.

// import React, { useEffect, useState, useContext } from 'react';
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Popup,
//   Tooltip,
//   useMap
// } from 'react-leaflet';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import 'leaflet.fullscreen/Control.FullScreen.css';
// import 'leaflet.fullscreen/Control.FullScreen';

// import { AppThemeContext } from '../../../../../../context/AppThemeContext';
// import { AuthenticationContext } from '../../../../../../context/AuthenticationContext';
// import { APP_KEY } from "../../../../../../api/AxiosApi";
// import { Link } from 'react-router-dom';
// import { BusinessApi, InverterDetail } from '../../../../../../api/Api';

// // Fullscreen button
// function FullscreenControlNative() {
//   const map = useMap();
//   useEffect(() => {
//     L.control.fullscreen({ position: "topleft" }).addTo(map);
//   }, [map]);
//   return null;
// }





// // Custom marker icons
// const redIcon = new L.Icon({
//   iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
//   shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
//   iconSize: [25, 41],
//   iconAnchor: [12, 41],
//   popupAnchor: [1, -34],
//   shadowSize: [41, 41]
// });

// const greenIcon = new L.Icon({
//   iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
//   shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
//   iconSize: [25, 41],
//   iconAnchor: [12, 41],
//   popupAnchor: [1, -34],
//   shadowSize: [41, 41]
// });

// export default function Dashboard7Location() {
//   const { PrimaryColor } = useContext(AppThemeContext);
//   const { userLogin } = useContext(AuthenticationContext);
//   const [logData, setLogData] = useState([]);


//   const [credentials] = useState({
//     LOGIN_ID: localStorage.getItem("LoginID") || "",
//     LOC_CODE: localStorage.getItem("LCODE") || "",
//     PASS_KEY: localStorage.getItem("PASS_KEY") || "xyz",
//     WEB_KEY: localStorage.getItem("WEB_KEY") || "WEBXYZ321",
//   });

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await InverterDetail(credentials);
//         if (res?.data && Array.isArray(res.data)) {
//           setLogData(res.data);
//         }
//       } catch (err) {
//         console.error("Error fetching data:", err);
//       }
//     };
//     fetchData();
//   }, [credentials.LOGIN_ID]);



//   // console.log("logdataMap", logData)

//   return (
//     <div style={{ height: "78vh" }}>
//       <MapContainer
//         center={[27.0, 80.0]}
//         zoom={5}
//         scrollWheelZoom={false}
//         style={{ height: "100%", width: "100%" }}
//         id="map"
//       >
//         <TileLayer
//           attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
//           url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//         />
//         {/* <FullscreenControlNative /> */}

//         {logData
//           .filter((data) => data.Latitude && data.Longitude)
//           .map((location, index) => {
//             const markerIcon = location.STS?.toLowerCase() === 'online' ? greenIcon : redIcon;
//             return (
//               <Marker
//                 key={index}
//                 position={[parseFloat(location.Latitude), parseFloat(location.Longitude)]}
//                 icon={markerIcon}
//               >
//                 <Tooltip direction="top" offset={[0, -20]} opacity={1}>
//                   <div className="tooltip-class">
//                   <strong><h6 className='text-primary'>
//                     {location.NAME}
//                   </h6></strong>
//                   <p><strong>Status:</strong> {location.STS}</p>
//                     <p><strong>Address:</strong> {location.USR}</p>


//                     <p><strong>Make:</strong> {location.MAKE}</p>
//                     <p><strong>Capacity (kWP):</strong> {location.KWP}</p>

//                     <p><strong>	Day kWh:</strong> {location.DAY_KWH} &nbsp;({location.E_DATE})</p>
//                     <p><strong>Total kWh:</strong> {location.TOT_GEN}</p>
//                     <p><strong>Instant KW:</strong> {location.KW}</p>
//                   </div>
//                 </Tooltip>
//                 <Popup>
//                   <strong><h6 className='text-primary'>
//                     {location.NAME}
//                   </h6></strong>
//                   <p><strong>Status:</strong> {location.STS}</p>
//                   <p><strong>Address:</strong> {location.USR}</p>


//                     <p><strong>Make:</strong> {location.MAKE}</p>
//                     <p><strong>Capacity (kWP):</strong> {location.KWP}</p>

//                     <p><strong>	Day kWh:</strong> {location.DAY_KWH} &nbsp;({location.E_DATE})</p>
//                     <p><strong>Total kWh:</strong> {location.TOT_GEN}</p>
//                     <p><strong>Instant KW:</strong> {location.KW}</p>
//                 </Popup>
//               </Marker>
//             );
//           })}
//       </MapContainer>
//     </div>
//   );
// }






import React, { useEffect, useState, useContext } from 'react';
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Tooltip,
  useMap
} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.fullscreen/Control.FullScreen.css';
import 'leaflet.fullscreen/Control.FullScreen';

import { AppThemeContext } from '../../../../../../context/AppThemeContext';
import { AuthenticationContext } from '../../../../../../context/AuthenticationContext';
import { APP_KEY } from "../../../../../../api/AxiosApi";
import { Link } from 'react-router-dom';
import { BusinessApi, InverterDetail } from '../../../../../../api/Api';

// Fullscreen button
function ResizeMapOnShow() {
  const map = useMap();

  useEffect(() => {
    setTimeout(() => {
      map.invalidateSize();
    }, 300); // enough time to render
  }, [map]);

  return null;
}







// Custom marker icons
const redIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const greenIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export default function Dashboard7Location() {
  const { PrimaryColor } = useContext(AppThemeContext);
  const { userLogin } = useContext(AuthenticationContext);
  const [logData, setLogData] = useState([]);


  const [credentials] = useState({
    LOGIN_ID: localStorage.getItem("LoginID") || "",
    LOC_CODE: localStorage.getItem("LCODE") || "",
    PASS_KEY: localStorage.getItem("PASS_KEY") || "xyz",
    WEB_KEY: localStorage.getItem("WEB_KEY") || "WEBXYZ321",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await InverterDetail(credentials);
        if (res?.data && Array.isArray(res.data)) {
          setLogData(res.data);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };
    fetchData();
  }, [credentials.LOGIN_ID]);



  // console.log("logdataMap", logData)

  return (
    <div style={{ height: "78vh" }}>
      <MapContainer
        center={[27.0, 80.0]}
        zoom={5}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
        id="map"
      >

        
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
<ResizeMapOnShow />

        {logData
          .filter((data) => data.Latitude && data.Longitude)
          .map((location, index) => {
            const markerIcon = location.STS?.toLowerCase() === 'online' ? greenIcon : redIcon;
            return (
              <Marker
                key={index}
                position={[parseFloat(location.Latitude), parseFloat(location.Longitude)]}
                icon={markerIcon}
              >
                <Tooltip direction="top" offset={[0, -20]} opacity={1}>
                  <div className="tooltip-class">
                    <strong><h6 className='text-primary'>
                      {location.NAME}
                    </h6></strong>
                    <p><strong>Status:</strong> {location.STS}</p>
                    <p><strong>Address:</strong> {location.USR}</p>


                    <p><strong>Make:</strong> {location.MAKE}</p>
                    <p><strong>Capacity (kWP):</strong> {location.KWP}</p>

                    <p><strong>	Day kWh:</strong> {location.DAY_KWH} &nbsp;({location.E_DATE})</p>
                    <p><strong>Total kWh:</strong> {location.TOT_GEN}</p>
                    <p><strong>Instant KW:</strong> {location.KW}</p>
                  </div>
                </Tooltip>
                <Popup>
                  <strong><h6 className='text-primary'>
                    {location.NAME}
                  </h6></strong>
                  <p><strong>Status:</strong> {location.STS}</p>
                  <p><strong>Address:</strong> {location.USR}</p>


                  <p><strong>Make:</strong> {location.MAKE}</p>
                  <p><strong>Capacity (kWP):</strong> {location.KWP}</p>

                  <p><strong>	Day kWh:</strong> {location.DAY_KWH} &nbsp;({location.E_DATE})</p>
                  <p><strong>Total kWh:</strong> {location.TOT_GEN}</p>
                  <p><strong>Instant KW:</strong> {location.KW}</p>
                </Popup>
              </Marker>
            );
          })}
      </MapContainer>
    </div>
  );
}